<template>
	<div>
		<div class="wrapper wrapper-content animated fadeInRight">
			<div class="row">
				<div class="col-lg-12">
					<div class="ibox float-e-margins">
						<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="padding: 0px;">
							<div class="table-filter-wrapper filterContainer">
								<input v-model="filterText" id="incomingsms-table-filter"
									type="text" name="incomingsms_filter" placeholder="Filter"
									autocomplete="incomingsms_filter">
								<img ng-click="focusInput()" src="/pbx2/assets/images/panel/search.svg">
							</div>
						</div>
						<div class="ibox-title">
							<h4 v-if="items && items.length">
								Items 1 to {{ items.length }} of
								{{ items.length }}
							</h4>
						</div>
						<div class="ibox-content">
							<Loading v-if="loading" />
							<table class="table footable table-stripped footable-loaded" v-if="!loading">
								<thead>
									<tr>
										<th>Type</th>
									</tr>
								</thead>
								<tbody>
									<tr class="gradeX" v-for="(item, index) in items"
										v-bind:key="item.key" data-index="0" style="display: table-row"
										:class="{}">
										<td>
											<span class="footable-toggle"></span>
											<input type="checkbox" v-model="selectedItems[index]"
												:value="item.id" />&nbsp;
												{{ item.label }}
											<!-- <router-link :to="{path:'edit/' + item.id}">{{ item.label }}</router-link> -->
										</td>
									</tr>
								</tbody>
								<tfoot>
									<td colspan="2">
										<router-link class="btn btn-sm btn-success mr-2" :to="{ name: routeNames.Create }">
											New</router-link>
										<button class="btn btn-sm btn-success mr-2" @click="deleteItem()"
											:disabled="selectedItems.length == 0">
											Delete Selected
										</button>
									</td>
								</tfoot>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {ExternalIntegrationApiService} from "../../services/ExternalIntegrationApiService";
import Loading from "../../components/Loading";
import {uuid} from "vue-uuid";
import {routeNames} from "../routeNames";
export default {
	data: () => ({
		loading: false,
		items: [],
		selectedItems: [],
		headers: ["number", "email", "enable_webhook"],
		selectAllButtonText: "Select All",
		images: null,
		filterText: "",
		numbersData: [],
		routeNames
	}),
	components: {Loading},
	created() {
		let $injector = this.$root.angularInjector;
		let CoreApiService = $injector.get("CoreApiService");
		this.SwalService = $injector.get("SwalService");
		this.ExternalIntegrationApiService = new ExternalIntegrationApiService(CoreApiService, this.$route.params.customer);
	},
	async mounted() {
		this.load();
	},
	computed: {
		filteredEvents() {
			if (this.filterText.length >= 2) {
				return this.items.filter(item => item.number.includes(this.filterText) || item.email.includes(this.filterText));
			}
			return this.items;
		}
	},
	methods: {
		async load() {
			this.loading = true;
			this.items = await this.ExternalIntegrationApiService.list({offset: "all"});
			this.selectedItems = new Array(this.items.length).fill(false);
			this.items = this.items.map(item => {
				item.key = uuid.v4();
				return item;
			});
			this.loading = false;
		},

		async deleteItem() {
			let numbersToDelete = [];
			if (!this.selectedItems.find(isSelected => isSelected === true)) {
				this.SwalService.popup({
					title: "Error",
					type: "warning",
					text: "You must select one or more items to delete"
				});
				return;
			}

			this.loading = true;

			this.selectedItems.forEach((isSelected, index) => {
				if (isSelected) {
					numbersToDelete.push(this.items[index].number);
				}
			});

			try {
				await this.ExternalIntegrationApiService.delete(numbersToDelete).then(result => {
					this.SwalService.popup({
						title: "Deleted",
						type: result.data > 0 ? "success" : "warning",
						text: result.data > 0 ? result.data + " numbers deleted!" : "ZERO number deleted!"
					}).then((s) => {
						this.selectedItems = [];
						this.load();
					});
				});
			}
			catch (e) {
				this.SwalService.popup({
					title: e.message || e.statusCode || e,
					type: "error"
				}).then((s) => {
					this.load();
				});
			}
			this.loading = false;
		}
	}
};
</script>

<style scoped>
.boldRed {
	color: rgb(255, 0, 0);
	font-weight: 700;
}

.lineThrough {
	text-decoration: line-through;
}

.deleted {
	color: red;
}

.expiredGreyOut {
	opacity: 0.25;
}

.dNone {
	display: none;
}

.filterContainer {
	position: absolute;
	top: 18px;
	right: 18px;
}
</style>
